(() => {
  if (customElements.get('pi-product-options')) return;
  class ProductOptions extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', event => {
        if (event.target.matches('[data-option-control]')) this.selectOptions();
      });
      this.syncPurchase(false);
      this.form?.addEventListener('submit', event => {
        if (this.loading || this.dataset.available !== 'true') event.preventDefault();
      });
    }
    get form() { return this.closest('form'); }
    syncPurchase(updateURL) {
      const form = this.form;
      if (!form) return;
      const id = form.querySelector('input[name="id"]');
      id.value = this.dataset.variantId || '';
      id.disabled = !this.dataset.variantId;
      const button = form.querySelector('[data-add-to-cart]');
      const available = this.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.availableText : (this.dataset.variantId ? button.dataset.soldText : 'Unavailable');
      const payment = form.querySelector('.shopify-payment-button');
      if (payment) payment.hidden = !available;
      if (this.dataset.variantId && this.dataset.mediaId && typeof showProductMedia === 'function') {
        showProductMedia(this.closest('.pi-product').querySelector('[data-product-gallery]'), this.dataset.mediaId);
      }
      if (updateURL) {
        const url = new URL(location.href);
        url.searchParams.delete('option_values');
        if (this.dataset.variantId) url.searchParams.set('variant', this.dataset.variantId);
        else url.searchParams.delete('variant');
        history.replaceState({}, '', url);
        id.dispatchEvent(new Event('change', {bubbles:true}));
      }
    }
    async selectOptions() {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      const button = this.form.querySelector('[data-add-to-cart]');
      button.disabled = true;
      const payment = this.form.querySelector('.shopify-payment-button');
      if (payment) payment.hidden = true;
      const ids = [...this.querySelectorAll('[data-option-group]')].map(group => group.querySelector('select, input:checked')?.value);
      const url = new URL(this.dataset.url, location.origin);
      url.searchParams.set('section_id', this.dataset.section);
      url.searchParams.set('option_values', ids.join(','));
      try {
        const response = await fetch(url, {signal:controller.signal});
        if (!response.ok) throw new Error('Unable to load options');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = html.querySelector('pi-product-options');
        if (!next) throw new Error('Missing product options');
        if (controller !== this.controller) return;
        const activeValue = document.activeElement?.value;
        this.innerHTML = next.innerHTML;
        ['variantId','available','mediaId'].forEach(key => { this.dataset[key] = next.dataset[key] || ''; });
        const price = this.closest('.pi-product').querySelector('[data-product-price]');
        const nextPrice = html.querySelector('[data-product-price]');
        if (price && nextPrice) price.innerHTML = this.dataset.variantId ? nextPrice.innerHTML : '';
        this.loading = false;
        this.syncPurchase(true);
        [...this.querySelectorAll('[data-option-control]')].find(control => control.value === activeValue)?.focus({preventScroll:true});
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.querySelector('[data-option-status]').textContent = 'Could not update your selection. Choose an option again to retry.';
        }
      } finally {
        if (controller === this.controller) this.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('pi-product-options', ProductOptions);
})();
